import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static values = {
    url: String,
    type: String
  }

  connect() {
    this.sortable = Sortable.create(this.element, {
      handle: "[data-sortable-handle]",
      animation: 150,
      ghostClass: "opacity-50",
      onEnd: this.onEnd.bind(this)
    })
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  }

  async onEnd(event) {
    const { oldIndex, newIndex } = event
    if (oldIndex === newIndex) return

    const row = event.item
    const id = row.dataset.sortableId

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
          "Accept": "application/json"
        },
        body: JSON.stringify({
          id: id,
          type: this.typeValue,
          position: newIndex
        })
      })

      if (!response.ok) {
        console.error("Failed to update position")
        this.sortable.sort(this.sortable.toArray())
      }
    } catch (error) {
      console.error("Error updating position:", error)
    }
  }
}
